import React, { useState } from 'react';
import ActionButton from 'client/components/Result/Actions/ActionButton';
import getWinnerLabelAndBtnTextGenerator from 'client/components/Result/utils/getWinnerLabelAndBtnTextGenerator';

export default function WinnerButton({
    lotteryType,
    btnStyle,
    onClick = async () => {},
    customBtnText
}) {
    const [isFetching, setIsFetching] = useState(false);
    const { btn } = getWinnerLabelAndBtnTextGenerator({
        lotteryType,
        customBtnText
    });
    return (
        <ActionButton
            text={btn()}
            onClick={async () => {
                setIsFetching(true);
                await onClick();
                setIsFetching(false);
            }}
            btnStyle={btnStyle}
            isLoading={isFetching}
        />
    );
}
